import React, {ReactElement} from 'react';

const ComparisonArrow = ({
  current,
  previous
}: {
  current: number;
  previous: number;
}): ReactElement => {
  const percentChange = current / previous - 1;

  const className = () => {
    const absPercent = Math.abs(percentChange);

    const modifier = percentChange > 0 ? 'plus' : 'minus';
    let weight;
    if (absPercent > 0.5) {
      weight = 'Dark';
    } else if (absPercent > 0.1) {
      weight = 'Medium';
    } else {
      weight = 'Light';
    }

    return `stores-ComparisonArrow stores-ComparisonArrow--${modifier} stores-ComparisonArrow--${
      modifier + weight
    }`;
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="20"
      viewBox="0 0 24 24"
      width="20"
      className={className()}>
      <title>{`Change of ${Math.round(percentChange * 100)}%`}</title>
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M7 14l5-5 5 5z" />
    </svg>
  );
};

export default ComparisonArrow;
